module.exports = __webpack_public_path__ + "img/media_set.e73dc5c1.png";